import React from "react";
import dayjs from "dayjs";
import { ICreateSalesData, IInvoice } from "../../@types";
import { useNavigate, useParams } from "react-router-dom";
import { formatMoney, getInvoiceStatus } from "../../utils";
import TimeyIcon from "../../assets/icons/timeyIcon";
import { getInvoice } from "../../backend-services";
import { ImSpinner } from "react-icons/im";

interface invoiceDetailsProp {
  invoice: IInvoice;
}

export const recurringColors: any = {
  paid: {
    text: "#039855",
    bg: "#ECFDF3",
  },
  active: {
    text: "#039855",
    bg: "#ECFDF3",
  },
  expired: {
    text: "#D92D20",
    bg: "#FEF3F2",
  },
  pending: {
    text: "#DC6803",
    bg: "#FFFAEB",
  },
  due: {
    text: "#D92D20",
    bg: "#FEF3F2",
  },
  paused: {
    text: "#DC6803",
    bg: "#FFFAEB",
  },
  draft: {
    text: "#03B8DC",
    bg: "#EBFCFF",
  },
  cancelled: {
    text: "#475467",
    bg: "#F9FAFB",
  },
  refunded: {
    text: "#044E97",
    bg: "#E0EEFE",
  },
};

export const RecurringDetails: React.FC<invoiceDetailsProp> = ({ invoice }) => {
  const { invoiceNo } = useParams();
  const navigate = useNavigate();

  const recurringStatusColor = recurringColors[invoice?.reoccurringStatus];

  const capitalizeFirstLetter = (str: string | undefined) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleClick = () => {
    navigate(`/invoices/${invoiceNo}/view`);
  };
  return (
    <>
      <div className="hidden md:block p-5 bg-[#ffffff] border-[1px] border-gray-200 rounded-[8px]">
        <div className="flex justify-between items-center">
          <div className="sm:flex item-center justify-start flex-1 md:gap-[4.4%] lg:gap-[2.2%]">
            <p className="text-gray-700 text-[18px]">
              {" "}
              {invoice?.invoiceNumber}
            </p>
            <span
              className={` px-2 py-1 rounded-[4px] text-[16px] font-medium capitalize flex justify-center bg-[${recurringStatusColor?.bg}] text-[${recurringStatusColor?.text}]`}
            >
              {invoice?.reoccurringStatus}
            </span>
          </div>
          <div className="">
            <button
              className="flex justify-end items-end mt-[-0.4em] text-right border border-[#044E97] text-[#044E97] bg-white py-2 px-[3em] rounded-md"
              onClick={handleClick}
            >
              View Invoice
            </button>
          </div>
        </div>

        {/*  */}
        <div>
          <h1 className="font-medium text-[24px] mt-5">
            {" "}
            {invoice?.customer.firstName} {invoice?.customer.lastName}
          </h1>

          <p className="text-gray-700 font-medium mt-4 flex flex-col text-[16px]">
            Amount
          </p>
          <div className="flex items-center space-x-3">
            <span className="mt-1 font-semibold text-gray-800 text-[20px]">
              {" "}
              {formatMoney(invoice?.balanceDue ?? 0, "NGN")}
            </span>
            <p className="mt-1 flex text-[18px] uppercase text-gray-600 font-medium">
              {capitalizeFirstLetter(invoice?.reoccurringGroupName)}
            </p>
          </div>
        </div>
      </div>

      <div className="md:hidden lg:hidden  p-5 bg-[#ffffff] border-[1px] border-gray-100  rounded-[8px]">
        <div className="flex gap-[5.2%]">
          <p className="text-gray-700 text-[18px]"> {invoice?.invoiceNumber}</p>
          <span
            className={` px-2 py-1 rounded-[4px] text-[16px] font-medium capitalize flex justify-center bg-[${recurringStatusColor?.bg}] text-[${recurringStatusColor?.text}]`}
          >
            {invoice?.reoccurringStatus}
          </span>
        </div>

        <div>
          <h1 className="font-semibold text-[20px] mt-[1em]">
            {" "}
            {invoice?.customer.firstName} {invoice?.customer.lastName}
          </h1>
          <p className="text-gray-600 mt-[1em] flex font-medium flex-col text-[16px]">
            Amount
          </p>
          <div className="flex items-center space-x-3">
            <span className="mt-1 font-semibold text-gray-800 text-[20px]">
              {" "}
              {formatMoney(invoice?.balanceDue ?? 0, "NGN")}
            </span>
            <p className="mt-1 flex text-[18px] uppercase text-gray-600 font-medium">
              {capitalizeFirstLetter(invoice?.reoccurringGroupName)}
            </p>
          </div>{" "}
        </div>

        <div className="w-full mt-5">
          <button
            className="w-full mt-[-0.4em] text-center font-medium text-[16px] border border-[#044E97] text-[#044E97] bg-white py-3 px-5 rounded-md"
            onClick={handleClick}
          >
            View Invoice
          </button>
        </div>
      </div>
    </>
  );
};
